import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const GridListTDAs = gql`
    query GridListTDAs ($typeDefinitionIndex: GridTypeDefinitionIndex!) {
        gridList {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
